import { storeToRefs } from "pinia";
import { watch } from "vue";

import { useConfigurationStore } from "@/stores/configuration/configuration-store";

interface IUseClientTimezoneOpts {
  onTimezoneChanged(timezone: string): void;
}

export function useClientTimezone(opts?: Partial<IUseClientTimezoneOpts>) {
  const configurationStore = useConfigurationStore();
  const { clientTimezone } = storeToRefs(configurationStore);

  watch(clientTimezone, (nextData) => {
    if (opts?.onTimezoneChanged) {
      opts.onTimezoneChanged(nextData);
    }
  });

  return clientTimezone;
}
